import { HourglassOutlined } from "@ant-design/icons";
import { FC } from "react";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const UsageWaitIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><HourglassOutlined/></span>;
